<div class="flex justify-end items-center gap-4 mb-2">
  <div *ngFor="let legend of legends" class="flex items-center gap-2">
    <span
      class="w-3 h-3 rounded-full"
      [style.backgroundColor]="legend.color"
    ></span>
    <span class="text-xs text-gray-700">{{ legend.label }}</span>
  </div>
</div>

<div class="map-container">
  <google-map
    #map
    height="100%"
    width="100%"
    [options]="mapOptions"
    [mapId]="mapId"
  >
    >
    <!-- círculos para agrupar -->
    <map-circle
      *ngFor="let cluster of leadClusters; trackBy: trackByClusterId"
      [options]="getCircleOptions(cluster)"
    >
    </map-circle>
  </google-map>
</div>
